/* eslint-disable */
export default function uploadFile () {
	$.fn.fileUploader = function (filesToUpload, sectionIdentifier) {
		var fileIdCounter = 0;
		this.closest('.c-file-upload').change(function (evt) {
			var output = [];
			if (evt.target.files.length < 9 ) {
				for (var i = 0; i < evt.target.files.length; i++) {
					fileIdCounter++;
					var file = evt.target.files[i];
					var fileId = sectionIdentifier + fileIdCounter;
					filesToUpload.push({
						id: fileId,
						file: file
					});

					var removeLink = '<a class="c-file-upload__remove-file" data-fileid="' + fileId + '"><span class="t-visually-hidden">Remove</span><i class="fa fa-times c-file-upload__file-icon" aria-hidden="true"></i></a>';

					output.push('<li><i class="fa fa-file-text-o" aria-hidden="true"></i> ', file.name, ' kommer att bifogas. ',removeLink, '</li>');
				}

				$(this).children('.c-file-upload__file-list')
					.append(output.join(''));

				// reset the input to null - nice little chrome bug!
				evt.target.value = null;
			}
			else {
				$('#alert-message-files').modal('show');
			}

		});
		$(this).on('click', '.c-file-upload__remove-file', function (e) {
			e.preventDefault();

			var fileId = $(this).parent().children('a').data('fileid');

			// loop through the files array and check if the name of that file matches FileName
			// and get the index of the match
			for (var i = 0; i < filesToUpload.length; ++i) {
				if (filesToUpload[i].id === fileId)
					filesToUpload.splice(i, 1);
			}

			$(this).parent().remove();
		});

		this.clear = function () {
			for (var i = 0; i < filesToUpload.length; ++i) {
				if (filesToUpload[i].id.indexOf(sectionIdentifier) >= 0)
					filesToUpload.splice(i, 1);
			}

			$(this).children('.c-file-upload__file-list').empty();
		};

		return this;
	};

	(function () {

		var inputField;
		var filesToUpload = [];
		var files1Uploader = $('.c-file-upload').fileUploader(filesToUpload, 'files1');

		$('.close-modal').click(function() {
			$('#ConfirmSendFiles').hide();
			$('.confirm-message').hide();
			$('.modal-backdrop').hide();
		});
		$('.upload-form__button').click(function (e) {
			e.preventDefault();
			inputField = $(this).siblings('.c-file-upload').find('input[type=hidden]').val();
			if(filesToUpload.length === 0 ) {
				$('#uploadFilesModal-no-files').modal('show');
			}
			else if ( filesToUpload.length <= 8){
				$('#uploadFilesModal').modal('show');
			}
			else if ( filesToUpload.length > 8 ) {
				$('#alert-message-files').modal('show');
			}
			else {
				console.log('');
			}
		});
		$('.cancel-response').on('click', function (e) {
			e.preventDefault();
			$('#alert-message-files').modal('hide');
			$('#uploadFilesModal').modal('hide');
			$('#uploadFilesModal-no-files').modal('hide');
		});
		$('.send-response').on("click", function (e) {
			e.preventDefault();

			$('#uploadFilesModal').modal('hide');
			$('#uploadFilesModal-no-files').modal('hide');

			var formData = new FormData();
			for (var i = 0, len = filesToUpload.length; i < len; i++) {
				formData.append('files', filesToUpload[i].file);
			}
			formData.append('code', inputField);
			$('button').attr('disabled', true);
			$.ajax({
				url: document.querySelector('.upload-form').getAttribute('action'),
				data: formData,
				processData: false,
				contentType: false,
				type: 'POST',
				success: function (data) {
					files1Uploader.clear();
					window.location.href = data.Url;
					$('.upload-files-decline').hide();
					$('.conf-response').show();
				},
				error: function (data) {
					alert('ERROR - ' + data.responseText);
					$('button').attr('disabled', false);
				}
			});
		});
		$('.additional-files').on("click", function (e) {
			e.preventDefault();
			inputField = $(this).siblings('.c-file-upload').find('input[type=hidden]').val();
			if( filesToUpload.length > 0 ) {

			var formData = new FormData();
			for (var i = 0, len = filesToUpload.length; i < len; i++) {
				formData.append('files', filesToUpload[i].file);
			}
			formData.append('code', inputField);

			$('button').attr('disabled', true);
			$.ajax({
				url: document.querySelector('.upload-form-additonal-files').getAttribute('action'),
				data: formData,
				processData: false,
				contentType: false,
				type: 'POST',
				success: function (data) {
					files1Uploader.clear();
					window.location.href = data.Url;
					$('.upload-files-decline').hide();
					$('.conf-response').show();
				},
				error: function (data) {
					alert('ERROR - ' + data.responseText);
					$('button').attr('disabled', false);
				}
			});

		} else {
			$('#alertNoDocuments').modal('show');
		}
		});
	})();
}
